module.exports = __webpack_public_path__ + "static/blog-index-3e6b48bc689b498736a78f16558e993e.jpg";